export const CALL_PRIORITY_MARKS = [
    { value: 0, label: 'Baixa' },
    { value: 5, label: 'Média' },
    { value: 8, label: 'Alta' },
    { value: 10, label: 'Muito Alta' }
];

export const getCallPriorityLabel = (value) =>
    CALL_PRIORITY_MARKS.find((mark) => mark.value === value)?.label || 'Média';

export const normalizeCallPriority = (value) => {
    const numeric = Number(value);

    if (!Number.isFinite(numeric)) {
        return 5;
    }

    return CALL_PRIORITY_MARKS.reduce((closest, mark) => {
        const currentDistance = Math.abs(mark.value - numeric);
        const closestDistance = Math.abs(closest.value - numeric);
        return currentDistance < closestDistance ? mark : closest;
    }, CALL_PRIORITY_MARKS[1]).value;
};

export const getCallPriorityColor = (value) => {
    switch (normalizeCallPriority(value)) {
    case 0:
        return '#6F8A5E';
    case 5:
        return '#D7A229';
    case 8:
        return '#E67E22';
    case 10:
        return '#D63731';
    default:
        return '#D7A229';
    }
};
